module.exports = __webpack_public_path__ + "img/ew-icon_new-message.4427b3ae.svg";